import factory from './icon';
import Svg from './glyphs/ic_error_outline_24px.svg';

export default factory(Svg);
